// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"107":"965cde84","239":"5491b2ce","389":"50b27349","732":"a38800b4","857":"5bae7941","881":"6bea065b","977":"cfa13509"}[chunkId] + ".chunk.js";
};